import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './HeaderLink.css'
import template from './HeaderLink.jinja'

var HeaderLink = Backbone.View.extend({
    initialize () {
    }
})

export default HeaderLink


// WEBPACK FOOTER //
// ./assets/app/front/components/HeaderLink/HeaderLink.js